import {request} from '@/utils/request'

// 业务管理 - 列表 - 分页
export function getBusinessList(data) {
  return request('GET', '/project/page', data, true)
}

// 业务管理 - 详情
// export function getBusinessInfo(id,data) {
//   return request('GET', '/partner/'+id, data, true)
// }
export function getBusinessInfo(id,data) {
  return request('GET', '/project/'+id, data, true)
}
export function getPartnerId(id,data) {
  return request('GET', '/partner/'+id, data, true)
}
// 业务管理 - 编辑
export function postBusinessEdit(data) {
  return request('POST', '/Project/edit', data, true)
}

// 业务管理 - 驳回
export function postBusinessStatus(data) {
  return request('POST', '/Project/false', data, true)
}










// 银行管理 - 列表 - 分页
export function getBusinessBankList(data) {
  return request('GET', '/bank/page', data, true)
}

// 银行管理 - 列表 - 所有
// export function getBusinessBankAll(data) {
//   return request('GET', '/bank/page', data, true)
// }

// 获得业务类型的list
export function getBusinessBankAll(data) {
  return request('GET', '/business-type/list', data, true)
}

// 获得银行的list
export function getBankAll(data) {
  return request('GET', '/bank/list', data, true)
}

// 获得有限制的业务类型的list
export function getTypePartner(data) {
  return request('GET', '/business-type/partner/list', data, true)
}
// 银行管理 - 添加
// export function postBusinessBankAdd(data) {
//   return request('POST', '/Bank/add', data, true)
// }
export function postBusinessBankAdd(data) {
  return request('POST', '/bank', data, true)
}
// 银行管理 - 信息
// export function getBusinessBankDesc(data) {
//   return request('GET', '/Bank/info', data, true)
// }
export function getBusinessBankDesc(data) {
  return request('GET', '/Bank/info', data, true)
}
// 银行管理 - 详情
export function getBusinessBankInfo(data) {
  return request('GET', '/Bank/edit', data, true)
}

// 银行管理 - 编辑
// export function postBusinessBankEdit(data) {
//   return request('POST', '/Bank/edit', data, true)
// }
export function postBusinessBankEdit(data) {
  return request('PUT', '/bank', data, true)
}


// 银行管理 - 启用/禁用
// export function postBusinessBankStatus(data) {
//   return request('POST', '/Bank/status', data, true)
// }
export function postBusinessBankStatus(id,status,data) {
  return request('PUT', '/bank/'+id+"/"+status, data, true)
}
// 银行管理 - 根据业务查询
export function getBusinessBankSelect(data) {
  return request('GET', '/Bank/listSelect', data, true)
}




// 业务类型 - 列表 - 分页
// export function getBusinessTypeList(data) {
//   return request('GET', '/profession/index', data, true)
// }

export function getBusinessTypeList(data) {
  return request('GET', '/business-type/page', data, true)
}
// 业务类型 - 列表 - 所有       修改
export function getBusinessTypeAll(data) {
  return request('GET', '/business-type/list', data, true)
}

// 业务类型 - 详情
// export function getBusinessTypeInfo(data) {
//   return request('GET', '/profession/info', data, true)
// }
export function getBusinessTypeInfo(id,data) {
  return request('GET', '/business-type/'+id, data, true)
}
// 业务类型 - 添加
// export function postBusinessTypeAdd(data) {
//   return request('POST', '/profession/add', data, true)
// }
export function postBusinessTypeAdd(data) {
  return request('POST', '/business-type', data, true)
}



// 业务类型 - 编辑
// export function postBusinessTypeEdit(data) {
//   return request('POST', '/profession/edit', data, true)
// }
export function postBusinessTypeEdit(data) {
  return request('PUT', '/business-type', data, true)
}


// 业务类型 - 启用/禁用
export function postBusinessTypeStatus(data) {
  return request('POST', '/Profession/status', data, true)
}

export function putBusinessTypeStatus(id,status,data) {
  return request('PUT', '/business-type/'+id+'/'+status, data, true)
}
// 业务类型 - 删除
// export function postBusinessTypeDel(data) {
//   return request('POST', '/professionType/del', data, true)
// }
export function postBusinessTypeDel(id,data) {
  return request('DELETE', '/business-type/'+id, data, true)
}

// 项目修改
export function putBusinessEdit(data) {
  return request('PUT', '/project', data, true)
}

// 项目驳回
export function putBusinessReject(data) {
  return request('PUT', '/project/reject', data, true)
}

